
import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
@Injectable()
export class NotificationService {
    constructor(private afs: AngularFirestore, private userService: UserService) {
    }
    pushNotification(message, userId) {
        this.afs.collection('users').doc(userId).collection('notifications').add(message);

    }
    pushMessagesNotification(message, userId, sendedKey) {

        this.afs.collection('users').doc(userId).collection('messagesNotifications').doc(sendedKey).set(message).then(() => {
            this.afs.collection('users').doc(userId).collection('messagesNotifications').doc(sendedKey).update({ isUnseen: true })
        })


    }
    pushFriendRequest(userId, request) {
        this.afs.collection('users').doc(userId).ref.get().then((snap => {
            let requester = {};
            this.afs.collection('users').doc(request).ref.get().then((user => {
                requester = {
                    firstname: user.data().firstname,
                    lastname: user.data().lastname,
                    username: user.data().username,
                    profileImage: user.data().profileImage,
                    date: Date.now(),
                    userKey: request,
                    isSeen: false,
                    email: user.data().email
                }

            })).then(() => {
                this.afs.collection('users').doc(userId).collection('friendRequests').doc(userId).set(requester).then(() => {
                    this.afs.collection('users').doc(userId).collection('requests').doc(request).set({ request: true }).then(() => {
                        this.afs.collection('users').doc(request).collection('requests').doc(userId).set({
                            username: snap.data().username
                        })
                    })
                })

            })

        }))
    }
    getUnseenNotifications() {
        if (this.userService.getUid())
            return this.afs.collection('users').doc(this.userService.getUid())
                .collection('notifications', ref => ref.where('isUnseen', '==', true)).valueChanges();
    }
    getNotifications(): Observable<any[]> {
        return this.userService.getUser().map(user => (user.notifications || []).reverse());
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/notification.service.ts